import type { SectorView } from '@/schemas/sectors'

/**
 * Query key factory.
 *
 * The view is part of the key even though it only reorders the same seven
 * records: the ordering is the server's answer, not the client's, so caching
 * it per view is what lets a member flick between By change and A–Z without a
 * refetch once each has been seen.
 */
export const sectorsKeys = {
  all: ['sectors'] as const,
  overviews: () => [...sectorsKeys.all, 'overview'] as const,
  overview: (view: SectorView) => [...sectorsKeys.overviews(), view] as const,
  /** One sector's metric medians, by sector SYMBOL. */
  stats: (symbol: string) => [...sectorsKeys.all, 'stats', symbol] as const,
}
